import React from 'react';
import SafeIcon from '../common/SafeIcon';

const SettingsPanel = ({ settings, setSettings }) => {
  const handleChange = (event) => {
    const { name, value } = event.target;

    setSettings((currentSettings) => ({
      ...currentSettings,
      [name]: value === '' ? '' : Number(value)
    }));
  };

  return (
    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 mb-8 flex flex-wrap gap-6 items-center justify-between print:p-4 print:border-gray-400 print:mb-6">
      <div className="flex items-center gap-3">
        <div className="p-3 bg-red-50 rounded-lg print:p-0 print:bg-transparent">
          <SafeIcon
            name="Settings"
            className="text-xl text-red-600 print:text-black"
          />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-gray-800 print:text-black">
            Globale Annahmen
          </h2>
          <p className="text-sm text-gray-500 print:text-gray-700">
            Basiswerte für alle Berechnungen
          </p>
        </div>
      </div>

      <div className="flex flex-wrap gap-6 items-center">
        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-600 mb-1 print:text-black">
            Stundensatz (€)
          </label>
          <input
            type="number"
            name="hourlyRate"
            value={settings.hourlyRate}
            onChange={handleChange}
            className="w-24 px-3 py-2 border border-gray-300 rounded-md focus:ring-red-500 focus:border-red-500 print:border-none print:p-0 font-bold"
          />
        </div>

        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-600 mb-1 print:text-black">
            Arbeitswochen / Jahr
          </label>
          <input
            type="number"
            name="weeksPerYear"
            value={settings.weeksPerYear}
            onChange={handleChange}
            className="w-24 px-3 py-2 border border-gray-300 rounded-md focus:ring-red-500 focus:border-red-500 print:border-none print:p-0 font-bold"
          />
        </div>
      </div>
    </div>
  );
};

export default SettingsPanel;